import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/modules/auth';
import { environment } from "src/environments/environment";
import { GlobalErrorCodes } from "src/app/modules/shared/models/shared-services";
import { Router } from "@angular/router";

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
    
    constructor(
      private router: Router,
      private authService: AuthService,
      ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let auth = this.authService.getAuthFromLocalStorage();
    const isSms = request.url.includes('api-sms') || request.url.includes(environment.sallaUrl);
    if(auth && !request.headers.keys().includes('Authorization') && !isSms){
      request = request.clone({
        headers : request.headers.set('Authorization',`Bearer ${auth.accessToken}`)
      })
      request = request.clone({
        headers : request.headers.set('Accept-Language','ar')
      })
    }
    
    return next.handle(request).pipe(catchError((error: HttpErrorResponse) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
      }

      if (error.error?.code == 302 && error.error?.form_code == GlobalErrorCodes.setEmailCode) {
        this.router.navigate(['auth/active-code'], {
            queryParams: {
                type: 'email'
            }
        });
    } 
      
      return throwError(error);
    }));
  }
}
